import { render, staticRenderFns } from "./Estatisticas.vue?vue&type=template&id=b61ec31a&"
import script from "./Estatisticas.vue?vue&type=script&lang=js&"
export * from "./Estatisticas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports